/** Label for webhook tenant selectors: readable name · (uuid). */

export function formatClientOptionLabel(client) {
  const display =
    client.name?.trim() ||
    client.fullName?.trim() ||
    client.company?.trim() ||
    client.email?.trim() ||
    'Client';
  const id = client.id ?? client._id ?? '';
  return `${display} (${id})`;
}
